import React, { createContext, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';

export const NotificacionContext = createContext();

export const NotificacionProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const mostrarNotificacion = (mensaje, tipo = "success") => {
    setSnackbar({
      open: true,
      message: mensaje,
      severity: tipo,
    });
  };

  const cerrarNotificacion = () => {
    setSnackbar({
      ...snackbar,
      open: false,
    });
  };

  return (
    <NotificacionContext.Provider
      value={{
        mostrarNotificacion,
        cerrarNotificacion,
      }}
    >
      {children}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={10000}
        onClose={cerrarNotificacion}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={cerrarNotificacion}
          severity={snackbar.severity}
          sx={{ width: "100%", padding: 2, borderRadius: 1, fontSize: '1.4rem' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </NotificacionContext.Provider>
  );
};